<template>
    <div>
        <b-card style="padding:0px 30px 0px 30px;">

            <b-row>
                <b-col md="6">
                    <h3>
                        Past Claims
                    </h3>
                </b-col>
                <b-col md="6" style="text-align: right;">
                    <base-button @click="addClaim()" type="danger" class="mb-4 bg-danger">Add Claim</base-button>
                </b-col>
            </b-row>

            <b-row style="font-size: 9pt; font-weight: bold; padding: 3px 0px 6px 0px; text-decoration: underline;">
                <b-col class="less-padding" style="flex-basis: 20%; ">
                    Date Of Loss
                </b-col>


                <b-col class="less-padding" style="flex-basis: 50%;">
                    Description of Loss
                </b-col>

                <b-col class="less-padding" style="flex-basis: 20%;">
                    Total Incurred

                </b-col>


                <b-col class="less-padding" style="flex-basis: 10%; align-content: center">

                </b-col>


            </b-row>

            <b-row v-for="(item, index) in model.listOfClaims" :key="index"
                style="padding: 3px 0px 3px 0px;font-size: 9pt; align-content: center;">


                <b-col class="less-padding" style="flex-basis: 20%;">
                    {{ formatDate(item.claim.dateOfLoss) }}
                </b-col>


                <b-col class="less-padding" style="flex-basis: 50%;">
                    {{ item.claim.descriptionOfLoss }}
                </b-col>

                <b-col class="less-padding" style="flex-basis: 20%;">
                    ${{ item.claim.totalIncurred }}

                </b-col>

                <b-col class="less-padding" style="align-content: center;flex-basis: 10%; padding: 0px; display: flex">
                    <base-button style="padding: 0px 5px 5px 5px; max-height: 30px;" class="bg-danger" type="danger"
                        icon @click="editClaim(item, index)">
                        <b-icon font-scale="0.9" icon="pencil-square"></b-icon></base-button>
                    <base-button style="padding: 0px 5px 5px 5px;color: red; max-height: 30px;" class="bg-white"
                        type="danger" @click="removeClaim(index)">
                        <b-icon font-scale="0.9" icon="trash"></b-icon></base-button>
                </b-col>




            </b-row>

            <b-row v-if="model.listOfClaims.length == 0">
                <b-col style="text-align: center;font-size: 10pt;margin-top: 5px;color: red;">Please add claim information to proceed.</b-col>
            </b-row>

        </b-card>

        <PastClaimModal ref="pastClaimModal" @saveClaim="saveClaim($event)" />

    </div>
</template>

<script>
import BaseInput from "../../../components/Inputs/BaseInput.vue";
import { Select, Option } from "element-ui";
import VueMultiselectComponent from 'vue-multiselect-component'
import { entsiaDropDowns } from "../../../assets/data/entsiaLOVs";
import PastClaimModal from "../modals/pastClaimModal.vue";

export default {
    name: "PastClaimsList",
    //policy_id: "",
    //selectedCustomerId: 0,
    props: {
        model: {
            type: Object
        },
    },
    data() {
        return {
            claimsList: [],
            // vehicleEditMode: 'add',
            // selectedItem: null,
            // selectedIdx: null,
            // freightTaskOptions: entsiaDropDowns.freightTaskOptions,
            // vehicleTypeOptions: entsiaDropDowns.vehicleTypeOptions,
        }
    },
    methods: {
        formatDate(dateString) {
            return this.$moment(new Date(dateString)).format("YYYY-MM-DD")
        },
        removeClaim(idx) {
            this.$emit('deletePastClaim', idx);
        },
        saveClaim(_item) {
            this.$emit('saveClaim', { item: _item, selectedItemIndex: this.selectedItemIndex, editMode: this.editMode });
        },
        addClaim() {
            this.editMode = "add";

            this.selectedItemIndex = 0;
            this.selectedItem = {
                "claim": {
                    "dateOfLoss": "",
                    "totalIncurred": "",
                    "descriptionOfLoss": "",
                    "claimProductSection": "CM"
                }
            }

            this.$refs["pastClaimModal"].openClaimModal(this.editMode, this.selectedItem, this.selectedItemIndex);
        },
        editClaim(_row, idx) {
            //this.$refs['pastClaimModal'].hide();

            console.log(_row);

            this.editMode = "edit";

            this.selectedItem = structuredClone(_row);
            this.selectedItemIndex = idx;

            this.$refs["pastClaimModal"].openClaimModal(this.editMode, this.selectedItem, this.selectedItemIndex);

        }
        // saveVehicle() {
        //     this.$emit('saveVehicle', this.selectedItem);
        //     this.$refs['vehicle-modal'].hide();
        // },
        // closeVehicleModal() {
        //     this.$refs['vehicle-modal'].hide();
        // },
        // openVehicleModal(_mode, _item, _idx) {

        //     //console.log(_mode,_item,_idx);

        //     console.log(_item.vehicle.vehicleType);

        //     this.vehicleEditMode = _mode;
        //     this.selectedItem = _item;
        //     this.selectedIdx = _idx;
        //     this.$refs['vehicle-modal'].show();
        // },
    },
    components: {
        BaseInput,
        [Select.name]: Select,
        [Option.name]: Option,
        //Spinner,
        //FileUpload,
        VueMultiselectComponent,
        PastClaimModal
    },
    async mounted() {
        //console.log("c13");
        //this.$refs['vehicle-modal'].show();

        //console.log(this._selectedItem);
        //this.selectedItem = this._selectedItem;
    }
}
</script>

<style></style>